<template>
  <div class="the-faq-list">
    <div v-for="(faq, index) in props.faqs" :key="`${index} + ${new Date()}`">
      <h3 class="section-name">{{ index }}</h3>

      <v-expansion-panels class="panels" v-for="(question, position) in faq" :key="position + question.id">
        <v-expansion-panel class="panel" elevation="0">
          <template #title>
             <div v-html="question.pergunta"></div>
            </template>
          <template #text>
             <div v-html="question.resposta"></div>
            </template>
          </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VExpansionPanel, VExpansionPanels } from 'vuetify/components';
const props = defineProps(['faqs'])
</script>

<style lang="scss" scoped></style>